// Contrail V3.7.0 — "Install the app": Android/Chrome install button, or iPhone "Share → Add to Home Screen" steps.
import { useEffect, useState } from "react";
import { canInstall, isIos, isStandalone, promptInstall } from "../lib/pwa";

export function useInstallable() {
  const [can, setCan] = useState(canInstall());
  useEffect(() => { const f = () => setCan(canInstall()); window.addEventListener("fw-installable", f); return () => window.removeEventListener("fw-installable", f); }, []);
  return can;
}

export default function InstallPrompt({ compact = false, onDone }: { compact?: boolean; onDone?: () => void }) {
  const can = useInstallable();
  if (isStandalone()) return compact ? null : <p className="sub">Installed — you're using the Tracking Fiji app.</p>;
  if (can) return (
    <div className="m-install">
      {!compact && <p className="sub">Add Tracking Fiji to your home screen. It opens full-screen, like an app.</p>}
      <button type="button" className="m-btn" onClick={async () => { await promptInstall(); onDone?.(); }}>Install app</button>
    </div>
  );
  if (isIos()) return (
    <div className="m-install">
      <p className="sub">To install on iPhone or iPad (Safari):</p>
      <ol className="m-steps">
        <li>Tap <b>Share</b> <span aria-hidden="true">⬆︎</span> at the bottom of Safari.</li>
        <li>Choose <b>Add to Home Screen</b>.</li>
        <li>Tap <b>Add</b>, then open <b>Tracking Fiji</b> from your home screen and sign in once.</li>
      </ol>
    </div>
  );
  return compact ? null : <p className="sub">To install: open this page in Chrome (Android) or Safari (iPhone) and use “Add to Home Screen”.</p>;
}
